export default __webpack_public_path__ + "static/media/3.cf6e16f6.png";